const toggleButton = document.getElementById('site-navigation-button');
const navigationContent = document.getElementById('site-navigation-content');
const navigation = document.getElementById('site-navigation');

const toggleButtonActiveClassName = 'hamburger--active';
const navigationContentActiveClassName = 'navigation__content--active';
const navigationActiveClassName = 'navigation--active';

if (toggleButton) {
    toggleButton.addEventListener('click', e => {
        const isActive = toggleButton.getAttribute('aria-expanded') === 'true';
        if (isActive) {
            navigationContent.classList.remove(navigationContentActiveClassName);
            navigation.classList.remove(navigationActiveClassName);
            toggleButton.classList.remove(toggleButtonActiveClassName);
            toggleButton.setAttribute('aria-expanded', 'false');
            body.style.overflow = 'auto';
        } else {
            navigationContent.classList.add(navigationContentActiveClassName);
            navigation.classList.add(navigationActiveClassName);
            toggleButton.classList.add(toggleButtonActiveClassName);
            toggleButton.setAttribute('aria-expanded', 'true');
            body.style.overflow = 'hidden';
        }
    });
}

const menuItemsWithFlyouts = Array.from(document.querySelectorAll('.menu__item--has-descendants'));
const menuItemActiveClass = 'menu__item--active';

menuItemsWithFlyouts.forEach(item => {
    item.addEventListener('click', e => {
        // for fine pointers with hover states (non-touch devices), let the click go through
        if (window.matchMedia('(pointer: fine)').matches) return;

        // close other active items
        menuItemsWithFlyouts
            .filter(el => el !== item)
            .forEach(el => el.classList.remove(menuItemActiveClass));

        // let the click go through if the item is already active
        const isActive = item.classList.contains(menuItemActiveClass);
        if (isActive) return;

        // activate (open) the clicked node
        item.classList.add(menuItemActiveClass);
        e.preventDefault();
    });
});

const menuItems = Array.from(document.querySelectorAll('#site-navigation .menu li > a')).forEach(item => {
    const previewItem = document.querySelector(`[data-preview-for="${item.parentElement.id}"]`);

    if (previewItem) {
        const showPreview = e => previewItem.hidden = false;
        const hidePreview = e => previewItem.hidden = true;
        item.addEventListener('mouseenter', showPreview);
        item.addEventListener('focusin', showPreview)
        item.addEventListener('mouseleave', hidePreview);
        item.addEventListener('focusout', hidePreview);
    }
});
